export const enUSAgenda = {
  title: 'Agenda',
  newEvent: 'New event',
  refresh: 'Refresh',
  agendaUpdated: 'Agenda updated',
  // states
  loading: 'Loading agenda…',
  loadError: 'Failed to load events',
  notConnected: 'Google is not connected',
  notConnectedHint: 'Connect a Google account in Settings to use the shared calendar.',
  notSelected: 'No calendar selected',
  notSelectedHint: 'A household manager can pick the family calendar in Settings.',
  goToSettings: 'Open Settings',
  noEvents: 'No upcoming events',
  noEventsHint: 'Add your first event to share it with the household.',
  // create dialog
  createDialogTitle: 'New event',
  titleLabel: 'Title',
  titlePlaceholder: 'e.g. Dentist appointment',
  allDayLabel: 'All day',
  startLabel: 'Start',
  endLabel: 'End',
  startDateLabel: 'Start date',
  endDateLabel: 'End date',
  locationLabel: 'Location',
  locationPlaceholder: 'Optional',
  notesLabel: 'Notes',
  notesPlaceholder: 'Optional',
  create: 'Create',
  cancel: 'Cancel',
  validationTitleRequired: 'Title is required',
  validationStartRequired: 'Start is required',
  validationEndRequired: 'End is required',
  validationEndAfterStart: 'End must be after start',
  // delete
  deleteTitle: 'Delete event?',
  deleteDescription: 'This removes "{{title}}" from the shared calendar. This cannot be undone.',
  delete: 'Delete',
  deleteAction: 'Delete event',
  // detail panel
  close: 'Close',
  whenLabel: 'When',
  descriptionLabel: 'Description',
  openInMaps: 'Open "{{location}}" in Google Maps',
  // toasts
  toastCreated: 'Event created',
  toastCreatedError: 'Failed to create event',
  toastDeleted: 'Event deleted',
  toastDeletedError: 'Failed to delete event',
  // display
  allDayBadge: 'All day',
  // redesign: coming-up + by-week feed
  comingUp: 'Coming up',
  todaySection: 'Today',
  weekThis: 'This week',
  weekNext: 'Next week',
  weekOf: 'Week of {{date}}',
  routineSummary: 'Routine · {{n}}',
  routineToggle: 'Toggle routine events',
  countToday: 'Today',
  countTomorrow: 'Tomorrow',
  countDays: 'in {{n}} days',
  emptyWeek: 'Nothing scheduled',
} as const;
